module.exports = {
    defaultLanguage: 'es',
    profileColor: {saturation: 78, brightness: 100},
    scssVariables: './src/styles/bnavisa2024',
    favicon: 'bnavisafavicon.ico',
    defaultPassword: 'default'
}